import Span from '../../tag/Span';
import { FormattedMessage } from 'react-intl';
import Row from '../../tag/Row';

let { id: module_id } = module;

const AppointmentLocation = ({ location }) => {
  return (
    <Row>
      <Span len="4" sm-len="12">
        <span className="appointment-modal-label">
          <FormattedMessage id={`${module_id}.location`} />
        </span>
      </Span>
      <Span len="8" sm-len="12">
        <span className="appointment-modal-text">{location}</span>
      </Span>
    </Row>
  );
};

export default AppointmentLocation;
